// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".instructions-card[data-v-15da7154] {\n  background-color: #f9fbfb;\n  border-radius: 10px;\n}", ""]);
// Exports
module.exports = exports;
